var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-avance"},[_c('div',{key:_vm.key,staticClass:"chart-avance-outter"},[_c('div',{class:{ 
          'chart-avance-inner': true,
          'danger': _vm.pjeAvance > 75
        },style:({ width: _vm.pjeAvance + '%'})},[_c('span',{class:{ 
        'chart-avance-valor': true,
        'light': _vm.pjeAvance > 55
      }},[_vm._v(_vm._s(_vm._f("numero")(_vm.pjeAvance,2, true))+"%")])])]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.descripcion))])])
}
var staticRenderFns = []

export { render, staticRenderFns }